/* ============================================================
   Cervi One — JS del tema (sin dependencias)
   ============================================================ */
(function () {
  'use strict';

  const theme = window.theme || {};
  const $ = (sel, root = document) => root.querySelector(sel);
  const $$ = (sel, root = document) => Array.from(root.querySelectorAll(sel));

  /* ---------- Dinero (formato de Shopify) ---------- */
  function formatMoney(cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    format = format || theme.moneyFormat || '${{amount}}';
    const placeholder = /\{\{\s*(\w+)\s*\}\}/;
    const fmt = (n, precision, thousands = ',', decimal = '.') => {
      if (isNaN(n) || n == null) return '0';
      n = (n / 100).toFixed(precision);
      const parts = n.split('.');
      const dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      return dollars + (parts[1] ? decimal + parts[1] : '');
    };
    const match = format.match(placeholder);
    if (!match) return format;
    let value;
    switch (match[1]) {
      case 'amount': value = fmt(cents, 2); break;
      case 'amount_no_decimals': value = fmt(cents, 0); break;
      case 'amount_with_comma_separator': value = fmt(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = fmt(cents, 0, '.', ','); break;
      case 'amount_with_apostrophe_separator': value = fmt(cents, 2, "'", '.'); break;
      case 'amount_no_decimals_with_space_separator': value = fmt(cents, 0, ' ', ''); break;
      case 'amount_with_space_separator': value = fmt(cents, 2, ' ', ','); break;
      default: value = fmt(cents, 2);
    }
    return format.replace(placeholder, value);
  }

  /* ---------- Toast ---------- */
  function toast(msg) {
    const t = $('#Toast');
    if (!t) return;
    t.textContent = msg;
    t.classList.add('is-visible');
    clearTimeout(t._timer);
    t._timer = setTimeout(() => t.classList.remove('is-visible'), 2600);
  }

  /* ---------- Barra de anuncios rotativa (móvil) ---------- */
  function initAnnouncement() {
    $$('.announce__track.is-rotating').forEach((track) => {
      const items = $$('.announce__item', track);
      let i = 0;
      items[0] && items[0].classList.add('is-active');
      setInterval(() => {
        items[i].classList.remove('is-active');
        i = (i + 1) % items.length;
        items[i].classList.add('is-active');
      }, 3500);
    });
  }

  /* ---------- Header ---------- */
  function initHeader() {
    document.addEventListener('click', (e) => {
      const menuBtn = e.target.closest('[data-menu-toggle]');
      if (menuBtn) {
        const nav = $('[data-nav]');
        const open = nav.classList.toggle('is-open');
        menuBtn.setAttribute('aria-expanded', open);
        return;
      }
      const searchBtn = e.target.closest('[data-search-toggle]');
      if (searchBtn) {
        const bar = $('[data-search-bar]');
        bar.hidden = !bar.hidden;
        if (!bar.hidden) $('input[type="search"]', bar).focus();
      }
    });
  }

  /* ---------- Carrito ---------- */
  const drawer = () => $('[data-cart-drawer]');

  function openCart() {
    const d = drawer();
    if (!d) { window.location.href = theme.routes.cart; return; }
    d.classList.add('is-open');
    d.setAttribute('aria-hidden', 'false');
    document.body.classList.add('is-locked');
  }
  function closeCart() {
    const d = drawer();
    if (!d) return;
    d.classList.remove('is-open');
    d.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('is-locked');
  }

  function updateCounts(count) {
    $$('[data-cart-count]').forEach((el) => {
      el.textContent = count;
      el.hidden = Number(count) === 0;
    });
  }

  async function refreshCart() {
    const d = drawer();
    const url = theme.routes.root.replace(/\/?$/, '/') + '?section_id=cart-drawer';
    const html = await fetch(url, { credentials: 'same-origin' }).then((r) => r.text());
    const doc = new DOMParser().parseFromString(html, 'text/html');
    const fresh = $('.drawer__panel', doc);
    if (d && fresh) $('.drawer__panel', d).innerHTML = fresh.innerHTML;
    const src = $('[data-cart-count-source]', doc);
    if (src) updateCounts(src.textContent.trim());
  }

  async function changeLine(line, quantity) {
    const d = drawer();
    d && d.classList.add('is-updating');
    try {
      const res = await fetch(theme.routes.cartChange + '.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ line: Number(line), quantity: Math.max(0, Number(quantity)) }),
      });
      const data = await res.json();
      if (data.status && data.description) toast(data.description);
      await refreshCart();
    } catch (err) {
      console.error(err);
      toast("Couldn't update your cart. Please try again.");
    } finally {
      d && d.classList.remove('is-updating');
    }
  }

  function initCart() {
    document.addEventListener('click', (e) => {
      if (e.target.closest('[data-cart-open]') && drawer()) {
        e.preventDefault();
        openCart();
        return;
      }
      if (e.target.closest('[data-cart-close]')) { closeCart(); return; }
      const lineBtn = e.target.closest('[data-line-change]');
      if (lineBtn) changeLine(lineBtn.dataset.lineChange, lineBtn.dataset.quantity);
    });
    document.addEventListener('keydown', (e) => { if (e.key === 'Escape') closeCart(); });

    // Envío AJAX de cualquier formulario de producto
    document.addEventListener('submit', async (e) => {
      const form = e.target.closest('form.product-form');
      if (!form) return;
      e.preventDefault();
      const btn = $('[data-add-button]', form);
      const errorBox = $('[data-form-error]', form);
      if (errorBox) errorBox.hidden = true;
      btn && btn.classList.add('is-loading');
      try {
        const res = await fetch(theme.routes.cartAdd + '.js', {
          method: 'POST',
          credentials: 'same-origin',
          headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body: new FormData(form),
        });
        const data = await res.json();
        if (!res.ok || data.status) {
          const msg = data.description || data.message || "Couldn't add to cart.";
          if (errorBox) { errorBox.textContent = msg; errorBox.hidden = false; } else { toast(msg); }
          return;
        }
        if (theme.cartDrawer === false || !drawer()) {
          window.location.href = theme.routes.cart;
          return;
        }
        await refreshCart();
        openCart();
      } catch (err) {
        console.error(err);
        form.submit(); // último recurso: envío normal
      } finally {
        btn && btn.classList.remove('is-loading');
      }
    });
  }

  /* ---------- Producto ---------- */
  function initProductSection(section) {
    const jsonEl = $('[data-product-json]', section);
    if (!jsonEl) return;
    const product = JSON.parse(jsonEl.textContent);
    const form = $('form.product-form', section);
    const idInput = $('[data-variant-id]', section);
    const addBtn = $('[data-add-button]', section);
    const addText = $('[data-add-text]', section);
    const defaultAddText = addText ? addText.textContent.trim() : theme.strings.addToCart;
    const stickyBtn = $('[data-sticky-submit]', section);
    const track = $('[data-gallery-track]', section);
    let qtyInput = $('[data-qty-input]', section);

    // Si no hay selector de cantidad visible, crea uno oculto para la oferta por cantidad
    if (!qtyInput && form) {
      qtyInput = document.createElement('input');
      qtyInput.type = 'hidden';
      qtyInput.name = 'quantity';
      qtyInput.value = '1';
      form.appendChild(qtyInput);
    }

    const currentOptions = () =>
      product.options.map((_, i) => {
        const checked = $(`input[data-option-index="${i}"]:checked`, section);
        return checked ? checked.value : null;
      });

    const findVariant = (opts) =>
      product.variants.find((v) => v.options.every((o, i) => opts[i] === null || o === opts[i]));

    function scrollToMedia(mediaId, smooth = true) {
      if (!track || !mediaId) return;
      const slide = $(`[data-media-id="${mediaId}"]`, track);
      if (slide) track.scrollTo({ left: slide.offsetLeft, behavior: smooth ? 'smooth' : 'auto' });
    }

    function updateOfferPrices(variant) {
      $$('[data-offer-price]', section).forEach((el) => {
        el.textContent = formatMoney(variant.price * Number(el.dataset.offerPrice));
      });
    }

    function onVariantChange() {
      const opts = currentOptions();
      opts.forEach((val, i) => {
        const label = $(`[data-option-label="${i}"]`, section);
        if (label && val !== null) label.textContent = val;
      });
      const variant = findVariant(opts);

      if (!variant) {
        if (addBtn) addBtn.disabled = true;
        if (addText) addText.textContent = theme.strings.unavailable;
        if (stickyBtn) stickyBtn.disabled = true;
        return;
      }

      if (idInput) idInput.value = variant.id;

      $$('[data-price]', section).forEach((el) => (el.textContent = formatMoney(variant.price)));
      const compare = $('[data-compare-price]', section);
      const badge = $('[data-save-badge]', section);
      const onSale = variant.compare_at_price && variant.compare_at_price > variant.price;
      if (compare) { compare.hidden = !onSale; if (onSale) compare.textContent = formatMoney(variant.compare_at_price); }
      if (badge) {
        badge.hidden = !onSale;
        if (onSale) {
          const pct = $('[data-save-pct]', badge);
          const amt = $('[data-save-amount]', badge);
          if (pct) pct.textContent = Math.floor(((variant.compare_at_price - variant.price) * 100) / variant.compare_at_price);
          if (amt) amt.textContent = formatMoney(variant.compare_at_price - variant.price);
        }
      }
      updateOfferPrices(variant);

      if (addBtn) addBtn.disabled = !variant.available;
      if (addText) addText.textContent = variant.available ? defaultAddText : theme.strings.soldOut;
      if (stickyBtn) stickyBtn.disabled = !variant.available;

      if (variant.featured_media) scrollToMedia(variant.featured_media.id);

      if (section.dataset.updateUrl === 'true' && window.history.replaceState) {
        const url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url.toString());
      }
    }

    const updateGifts = () => {
      const q = parseInt(qtyInput && qtyInput.value, 10) || 1;
      $$('[data-gift-qty]', section).forEach((g) => g.classList.toggle('is-unlocked', q >= Number(g.dataset.giftQty)));
    };
    section.addEventListener('change', (e) => {
      if (e.target.matches('input[data-option-index]')) onVariantChange();
      if (e.target.matches('input[data-offer-qty]') && qtyInput) qtyInput.value = e.target.value;
      updateGifts();
    });
    section.addEventListener('click', (e) => { if (e.target.closest('[data-qty-step]')) setTimeout(updateGifts, 0); });

    // Botones +/- de cantidad
    section.addEventListener('click', (e) => {
      const step = e.target.closest('[data-qty-step]');
      if (step && qtyInput) {
        qtyInput.value = Math.max(1, (parseInt(qtyInput.value, 10) || 1) + Number(step.dataset.qtyStep));
      }
    });

    // Oferta por cantidad preseleccionada
    const offerChecked = $('input[data-offer-qty]:checked', section);
    if (offerChecked && qtyInput) qtyInput.value = offerChecked.value;
    updateGifts();

    // Galería
    if (track) {
      const slides = $$('.gallery__slide', track);
      const thumbs = $$('[data-thumb]', section);
      const go = (dir) => track.scrollBy({ left: dir * track.clientWidth, behavior: 'smooth' });
      const prev = $('[data-gallery-prev]', section);
      const next = $('[data-gallery-next]', section);
      prev && prev.addEventListener('click', () => go(-1));
      next && next.addEventListener('click', () => go(1));
      thumbs.forEach((t) => t.addEventListener('click', () => scrollToMedia(t.dataset.thumb)));
      let raf;
      track.addEventListener('scroll', () => {
        cancelAnimationFrame(raf);
        raf = requestAnimationFrame(() => {
          const idx = Math.round(track.scrollLeft / track.clientWidth);
          const active = slides[idx];
          if (!active) return;
          thumbs.forEach((t) => t.classList.toggle('is-active', t.dataset.thumb === active.dataset.mediaId));
          const activeThumb = thumbs.find((t) => t.dataset.thumb === active.dataset.mediaId);
          activeThumb && activeThumb.scrollIntoView({ block: 'nearest', inline: 'nearest' });
        });
      }, { passive: true });

      // Posiciona en la imagen de la variante seleccionada al cargar
      const selected = findVariant(currentOptions());
      if (selected && selected.featured_media) scrollToMedia(selected.featured_media.id, false);
    }

    // Barra fija de compra
    const sticky = $('[data-sticky-atc]', section);
    if (sticky && addBtn && 'IntersectionObserver' in window) {
      sticky.hidden = false;
      new IntersectionObserver(([entry]) => {
        const passed = !entry.isIntersecting && entry.boundingClientRect.top < 0;
        sticky.classList.toggle('is-visible', passed);
      }).observe(addBtn);
      stickyBtn && stickyBtn.addEventListener('click', () => {
        if (form.requestSubmit) form.requestSubmit(addBtn); else addBtn.click();
      });
    }
  }





  /* ---------- Encabezado inteligente y transparente ---------- */
  function initStickyHeader() {
    const wrap = $('.section-header');
    const header = $('[data-header]');
    if (!wrap || !header) return;
    const mode = header.dataset.sticky;
    let last = window.scrollY;
    const onScroll = () => {
      const y = window.scrollY;
      header.classList.toggle('is-solid', y > 10);
      if (mode === 'smart') {
        const goingDown = y > last && y > 160;
        const menuOpen = !!$('.nav-dropdown[open]', header);
        wrap.classList.toggle('is-hidden', goingDown && !menuOpen);
      }
      last = y;
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
    // Cerrar desplegables al hacer clic fuera
    document.addEventListener('click', (e) => {
      $$('.nav-dropdown[open]').forEach((d) => { if (!d.contains(e.target)) d.removeAttribute('open'); });
    });
    // Solo un desplegable abierto a la vez
    $$('.nav-dropdown').forEach((d) => d.addEventListener('toggle', () => {
      if (d.open) $$('.nav-dropdown[open]').forEach((o) => { if (o !== d) o.removeAttribute('open'); });
    }));
  }

  /* ---------- Menú de pantalla completa (celular) ---------- */
  function initDrawers() {
    document.addEventListener('click', (e) => {
      const opener = e.target.closest('[data-drawer-open]');
      if (opener) {
        const d = document.getElementById(opener.dataset.drawerOpen);
        if (!d) return;
        d.classList.add('is-open'); d.setAttribute('aria-hidden', 'false');
        opener.setAttribute('aria-expanded', 'true');
        document.body.classList.add('is-locked');
        const first = d.querySelector('a, button'); first && first.focus();
        return;
      }
      if (e.target.closest('[data-drawer-close]')) closeDrawers();
    });
    document.addEventListener('keydown', (e) => { if (e.key === 'Escape') closeDrawers(); });
  }
  function closeDrawers() {
    $$('[data-drawer].is-open').forEach((d) => { d.classList.remove('is-open'); d.setAttribute('aria-hidden', 'true'); });
    $$('[data-drawer-open]').forEach((b) => b.setAttribute('aria-expanded', 'false'));
    if (!$('[data-cart-drawer].is-open')) document.body.classList.remove('is-locked');
  }

  /* ---------- Animaciones al hacer scroll ---------- */
  function initReveal(root = document) {
    const items = $$('[data-reveal]:not(.is-in)', root);
    if (!document.body.classList.contains('anim') || !('IntersectionObserver' in window)) {
      items.forEach((el) => el.classList.add('is-in'));
      return;
    }
    const io = new IntersectionObserver((entries) => {
      entries.forEach((en) => { if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); } });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    items.forEach((el) => io.observe(el));
  }

  /* ---------- Pestañas accesibles ---------- */
  function initTabs(root = document) {
    $$('[data-tabs]', root).forEach((wrap) => {
      const tabs = $$('[role="tab"]', wrap);
      const select = (tab) => {
        tabs.forEach((t) => {
          const on = t === tab;
          t.setAttribute('aria-selected', on); t.tabIndex = on ? 0 : -1;
          const panel = document.getElementById(t.getAttribute('aria-controls'));
          if (panel) panel.hidden = !on;
        });
      };
      tabs.forEach((t, i) => {
        t.addEventListener('click', () => select(t));
        t.addEventListener('keydown', (e) => {
          let n = null;
          if (e.key === 'ArrowRight') n = tabs[(i + 1) % tabs.length];
          if (e.key === 'ArrowLeft') n = tabs[(i - 1 + tabs.length) % tabs.length];
          if (e.key === 'Home') n = tabs[0];
          if (e.key === 'End') n = tabs[tabs.length - 1];
          if (n) { e.preventDefault(); select(n); n.focus(); }
        });
      });
    });
  }

  /* ---------- Popup, volver arriba ---------- */
  function initFloating() {
    const promo = $('[data-promo]');
    if (promo && promo.showModal) {
      let seen = false;
      try { seen = sessionStorage.getItem('promo_seen') === '1'; } catch (e) {}
      // Si se acaba de enviar el formulario, mostrar el mensaje de éxito
      if (/customer_posted=true|form_type=customer/.test(location.search) || promo.querySelector('.form-success')) seen = false;
      if (!seen) {
        setTimeout(() => { if (!promo.open) promo.showModal(); }, (Number(promo.dataset.delay) || 5) * 1000);
        promo.addEventListener('close', () => { try { sessionStorage.setItem('promo_seen', '1'); } catch (e) {} });
      }
    }
    const top = $('[data-scroll-top]');
    if (top) {
      const toggle = () => { top.hidden = window.scrollY < 600; };
      window.addEventListener('scroll', toggle, { passive: true });
      toggle();
      top.addEventListener('click', () => window.scrollTo({ top: 0, behavior: 'smooth' }));
    }
  }

  /* ---------- Ventanas emergentes (dialog) ---------- */
  document.addEventListener('click', (e) => {
    const opener = e.target.closest('[data-dialog-open]');
    if (opener) {
      const dlg = document.getElementById(opener.dataset.dialogOpen);
      if (dlg && dlg.showModal) dlg.showModal();
      return;
    }
    if (e.target.closest('[data-dialog-close]')) { e.target.closest('dialog').close(); return; }
    if (e.target.tagName === 'DIALOG') e.target.close(); // clic fuera del contenido
  });

  /* ---------- Carruseles y videos ---------- */
  function initCarousels(root = document) {
    $$('[data-carousel]', root).forEach((wrap) => {
      if (wrap.dataset.ready) return;
      wrap.dataset.ready = '1';
      const track = $('[data-carousel-track]', wrap);
      if (!track) return;
      const step = () => {
        const card = track.firstElementChild;
        return card ? card.getBoundingClientRect().width + 16 : track.clientWidth;
      };
      const prev = $('[data-carousel-prev]', wrap);
      const next = $('[data-carousel-next]', wrap);
      prev && prev.addEventListener('click', () => track.scrollBy({ left: -step(), behavior: 'smooth' }));
      next && next.addEventListener('click', () => track.scrollBy({ left: step(), behavior: 'smooth' }));
    });
  }

  document.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-video-sound]');
    if (!btn) return;
    const video = btn.parentElement.querySelector('video');
    if (!video) return;
    // Silencia los demás videos para que solo suene uno
    $$('video').forEach((v) => { if (v !== video) v.muted = true; });
    video.muted = !video.muted;
    if (!video.muted) video.play();
    btn.classList.toggle('is-on', !video.muted);
  });

  document.addEventListener('DOMContentLoaded', () => {
    initAnnouncement();
    initHeader();
    initCart();
    $$('[data-product-section]').forEach(initProductSection);
    initCarousels();
    initFloating();
    initStickyHeader();
    initDrawers();
    initReveal();
    initTabs();
  });

  // Soporte para el editor de temas de Shopify
  document.addEventListener('shopify:section:load', (e) => {
    const s = $('[data-product-section]', e.target);
    s && initProductSection(s);
    initAnnouncement();
    initCarousels(e.target);
    initReveal(e.target);
    initTabs(e.target);
  });

  window.themeCart = { open: openCart, close: closeCart, refresh: refreshCart, formatMoney };
})();
